export enum IntentType {
    Checkout = 'checkout',
    Invoice = 'invoice',
    PaymentMethod = 'payment-method',
    Order = 'order',
    Onboard = 'onboard',
    CreditLine = 'credit-line',
    BuyerSignup = 'signup',
    BuyerSignatory = 'buyer-signatory',
    SupplierOnboard = 'supplier-onboard',
    Organization = 'organization',
    BuyerInvoice = 'buyer-invoice',
    PaymentLink = 'payment-link',
    Signup = 'signup-generic',
    AddContact = 'add-contact',
    SignupInvite = 'signup-invite',
    CreateBuyer = 'create-buyer',
    UploadLogo = 'upload-logo',
    FinancialConnection = 'financial-connection',
    FinancialConnectionReconnect = 'financial-connection-reconnect',
    SupplierAgreement = 'supplier-agreement',
    PaymentProcessingAgreement = 'payment-processing-agreement',
    SupplierDocuments = 'supplier-documents',
    SupplierBankAccount = 'supplier-bank-account',
    SupplierSignatory = 'supplier-signatory',
    Signatory = 'signatory',
    SupplierDataConnection = 'supplier-data-connection',
    BuyerGuarantee = 'buyer-guarantee',
    BuyerOwner = 'buyer-owner',
    VerifyIdentity = 'verify-identity',
    InvoiceSearch = 'invoice-search',
    CurrencyExchange = 'currency-exchange',
    WithdrawalBalance = 'withdrawal-balance',
    WithdrawWalletBalance = 'withdraw-wallet-balance',
    ConvertWalletBalance = 'convert-wallet-balance',
    RequestCover = 'request-cover',
    CompanySearch = 'company-search',
    CreditReference = 'credit-reference',
    GuestBuyerLink = 'guest-buyer-link',
    InsuranceApplication = 'insurance-application',
    ManualInsuranceCover = 'manual-insurance-cover',
    GuestCreditLineLink = 'guest-credit-line-link',
    LandingPageGuest = 'landing-page-guest',
    UploadProofOfPayment = 'upload-proof-of-payment',
}
